import {Alert, Button, Checkbox, DatePicker, Form, Input, Select} from 'antd';
import {useForm} from 'antd/lib/form/Form';
import * as React from 'react';
import {useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router';
import {AccountBean, ScheduledReportRequestObject} from 'src/api/api';
import {formDataLoader, FormDataType} from 'src/util/FormDataLoader';
import scheduledReportApi from './ScheduledReportApi';
import moment from 'dayjs';
import {isAdmin} from '../../../util/Util';
import {useUser} from '../../../context/UserContext';

const FormItem = Form.Item;
const Option = Select.Option

interface Props {

}

const formInfoItems: FormDataType[] = [
    FormDataType.Accounts
]

const frequencyEnum = ScheduledReportRequestObject.FrequencyEnum

export const ScheduledReportEdit: React.FC<Props> = () => {

    const [form] = useForm()
    const {user} = useUser()
    const admin = isAdmin(user)

    const [error, setError] = useState()
    const [info, setInfo] = useState({
        accounts: []
    })
    const [nextReport, setNextReport] = useState<any>()
    const [lastReport, setLastReport] = useState<moment.Dayjs>()
    const history = useHistory()

    const {id} = useParams<{ id?: string }>()

    const handleSubmit = () => {
        form.validateFields().then(values => {
            scheduledReportApi
                .edit(Number.parseInt(id ?? '-1'), {...values, nextReport: nextReport.format('YYYY-MM-DD HH:mm')})
                .then(history.goBack)
                .catch(err => {
                    setError(err.error)
                })
        })
    }

    useEffect(() => {
        scheduledReportApi
            .view(Number.parseInt(id ?? '-1'))
            .then(scheduledReportRequestobject => {
                const bean = scheduledReportRequestobject.data
                if (!bean) {
                    return
                }
                form.setFieldsValue(bean)
                bean.nextReport && setNextReport(moment(bean.nextReport))
                bean.lastReport && setLastReport(moment(bean.lastReport))
                formDataLoader(...formInfoItems)
                    .then(formInfo => setInfo(formInfo as any))
            })
            .catch(err => {
                setError(err.error)
            })
    }, [])

    return (
        <Form
            style={{
                maxWidth: '1000px'
            }}
            onFinish={handleSubmit}
            form={form}
            labelCol={{span: 5}}
            wrapperCol={{span: 19}}
        >
            {error ? <Alert message={error} type="error"/> : null}
            <FormItem
                name="name"
                rules={[
                    {
                        required: true,
                        message: 'Please input HouseCreative name'
                    },
                    {
                        max: 255,
                        message: 'Name cannot be longer that 255 characters'
                    }
                ]}
                label="Name"
                tooltip={'Name of the HouseCreative'}
            >
                <Input/>
            </FormItem>
            <FormItem
                label="Next Report"
                tooltip={'Next report date'}
                rules={[
                    {
                        required: true,
                        message: 'Please choose date'
                    }
                ]}
            >
                <DatePicker value={nextReport} onChange={(d) => setNextReport(d)}
                            format="YYYY-MM-DD HH:mm" showTime={{format: 'YYYY-MM-DD HH:mm'}}/>
            </FormItem>
            <FormItem
                name="frequency"
                rules={[
                    {
                        required: true,
                        message: 'Please select Format'
                    }
                ]}
                label="Frequency"
                tooltip={'Report frequency'}
            >
                <Select placeholder="Select frequency">
                    {Object
                        .keys(frequencyEnum)
                        .map((mode) => <Option key={mode}
                                               value={mode}>{mode.replace(/([a-z])([A-Z])/g, '$1 $2')}</Option>)}
                </Select>
            </FormItem>
            {admin && <FormItem
                name="account"
                label="Account"
                tooltip={'Select account'}
            >
                <Select
                    showSearch
                    allowClear
                    placeholder="Select account"
                >
                    {info.accounts.map((item: AccountBean) => <Option key={item.id}
                                                                      value={item.id as number}>{item.username}</Option>)}
                </Select>
            </FormItem>}
            <FormItem
                name="active"
                label="Active"
                valuePropName="checked"
                initialValue={true}
                tooltip={'If true report will generating'}
            >
                <Checkbox/>
            </FormItem>
            {lastReport && <div>
                <FormItem
                    label="Last Report"
                    name="lastReport"
                >
                    <Input readOnly={true}/>
                </FormItem>
                <FormItem
                    name="lastReportDates"
                    label="Last report period"
                >
                    <Input readOnly={true}/>
                </FormItem>
            </div>
            }
            <FormItem
                name="status"
                label="Status"
                tooltip={'Status of last report'}
            >
                <Input readOnly={true}/>
            </FormItem>
            <FormItem
                wrapperCol={{
                    offset: 11, span: 6
                }}>
                <Button style={{
                    width: '45%',
                    margin: '0 2%'
                }} type="primary" htmlType="submit">Save</Button>
                <Button style={{
                    width: '45%',
                    margin: '0 2%'
                }} type="primary" danger htmlType="button" onClick={history.goBack}>Cancel</Button>
            </FormItem>
        </Form>
    )
}
